<template>
  <van-popup
    v-model="show"
    position="bottom"
    round
    safeAreaInsetBottom
    :style="styleObj"
    @closed="popClosed"
  >
    <div class="pop-title">
      <span>{{ title }}</span>
      <van-icon name="cross" class="close-icon" @click="closeSheet" />
    </div>
    <div class="pop-content">
      <slot></slot>
    </div>
  </van-popup>
</template>
<script>
  export default {
    name: 'PdfActionSheet',
    filters: {},
    components: {},
    mixins: [],
    props: {
      title: {
        type: String,
        default: ''
      },
      styleObj: {
        type: Object,
        default: function() {
          return { height: '70%' }
        }
      },
      value: Boolean
    },
    data() {
      return {
        show: this.value || false
      }
    },
    computed: {},
    watch: {
      value(val) {
        this.show = val
      }
    },
    beforeCreate() {},
    created() {},
    beforeMount() {},
    mounted() {},
    beforeUpdate() {},
    updated() {},
    beforeDestroy() {},
    destroyed() {},
    activated() {},
    methods: {
      closeSheet() {
        this.show = false
        // this.$emit('input', false)
      },
      popClosed() {
        this.$emit('input', false)
      }
    }
  }
</script>
<style lang="scss" scoped>
  .pop-title {
    position: relative;
    text-align: center;
    line-height: 4rem;
    // font-weight: bold;
    font-size: 1.1rem;
    color: #333;
  }
  .close-icon {
    position: absolute;
    right: 0;
    top: 0;
    margin-right: 1rem;
    line-height: 4rem;
    font-size: 1.2rem;
  }
  .pop-content {
    height: calc(100% - 4rem);
    overflow: scroll;
    overflow-x: hidden;
    padding-bottom: 0.5rem;
  }
</style>
